import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { WizardN35Component } from './wizard-n35.component';
import {MatTreeModule} from '@angular/material/tree';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AutosizeModule} from 'ngx-autosize';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';


import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';


//import { BlankComponent } from '../pagina/blank/blank.component';
//import { CardedFullWidth2Component } from '../pagina/carded/full-width-2/full-width-2.component';

/// TESTING
import { WizardN35RutasModule } from './wizard-n35.rutas.module';

// N35


@NgModule({
  declarations: [WizardN35Component],
  imports     : [
      //RouterModule.forChild(routes),
      //routes,
      RouterModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatSelectModule,
      TranslateModule,
      FuseSharedModule,
      FuseSidebarModule,
      WizardN35RutasModule, // Cambiar
      MatTreeModule,
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      AutosizeModule,
      MatButtonToggleModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatProgressSpinnerModule
  ],
  exports     : [
      WizardN35Component, //Cambiar
  ]
})
export class WizardN35Module { }
